const SELECTORS = {
  form: "form",
  shopifySection: ".shopify-section",
  showMore: "[data-filter-show-more]",
  filterSection: "[data-filter-section]",
  filterExtra: "[data-filter-extra]",
};

class FacetFilters extends HTMLElement {
	connectedCallback() {
		this.form = this.querySelector(SELECTORS.form);
		if (!this.form) return;

		this.form.addEventListener("change", (event) => {
			if (event.target.matches("input, select")) {
				void this.onChangeHandler();
			}
		});

		this.addEventListener("click", (event) => {
			const toggle = event.target.closest(SELECTORS.showMore);
			if (!toggle) return;
			event.preventDefault();
			this.#onShowMoreClick(toggle);
		});
	}

	#onShowMoreClick(toggle) {
		const section = toggle.closest(SELECTORS.filterSection);
		if (!section) return;
		const extras = section.querySelectorAll(SELECTORS.filterExtra);
		const isExpanded = toggle.getAttribute("aria-expanded") === "true";
		const next = !isExpanded;
		extras.forEach((el) => el.classList.toggle("hidden", !next));
		toggle.setAttribute("aria-expanded", String(next));
		const showMoreLabel = toggle.dataset.showMoreLabel;
		const showLessLabel = toggle.dataset.showLessLabel;
		if (showMoreLabel && showLessLabel) {
			toggle.textContent = next ? showLessLabel : showMoreLabel;
		}
	}

	async onChangeHandler() {
		const formData = new FormData(this.form);
		const params = new URLSearchParams();

		for (const [key, value] of formData.entries()) {
			if (typeof value === "string") params.append(key, value);
		}

		const searchParams = params.toString();

		const collectionUrl = this.getCollectionUrl();

		if (!collectionUrl) return;

		const collectionPath = collectionUrl.pathname;

		if (window.location.pathname !== collectionPath) {
			await this.renderSectionFromAJAX(searchParams, collectionPath);
		} else {
			this.form.submit();
		}
	}

	getCollectionUrl() {
		const suffix = this.dataset.ffCollectionUrl;
		if (!suffix) return null;
		return new URL(suffix, window.location.origin);
	}

	async renderSectionFromAJAX(searchParams, collectionPath) {
		const sectionEl = this.closest(SELECTORS.shopifySection);
		if (!sectionEl?.id) return;

		const sectionId = sectionEl.id.replace("shopify-section-", "");

		const url = new URL(collectionPath, window.location.origin);
		url.search = searchParams;
		url.searchParams.set("sections", sectionId);

		try {
			const response = await fetch(url.toString());
			if (!response.ok) throw new Error(`HTTP ${response.status}`);

			const json = await response.json();
			const htmlString = json[sectionId];
			if (!htmlString) return;

			const temp = document.createElement("div");
			temp.innerHTML = htmlString;

			const newSection = temp.querySelector(`#shopify-section-${sectionId}`);
			const destination = document.getElementById(
				`shopify-section-${sectionId}`,
			);

			if (newSection && destination) {
				destination.replaceWith(newSection);
			}

			if (window.location.pathname === collectionPath) {
				const visibleUrl = `${collectionPath}${url.search}`;
				window.history.replaceState({ path: visibleUrl }, "", visibleUrl);
			}
		} catch (error) {
			console.error("AJAX Error:", error);
		}
	}
}

if (!customElements.get("facet-filters")) {
	customElements.define("facet-filters", FacetFilters);
}